module.exports = __webpack_public_path__ + "static/media/logo1.04f54bb0.png";